export default __webpack_public_path__ + "fbf02a43209a2424e5d183ea8c405acb.svg";